import { useEffect } from 'react';


function useSelectSnippetEffect(onExcerptSelected, snippet) {
    useEffect(() => {
        if ( snippet ) {
            onExcerptSelected(snippet);
        }
    }, [snippet]);    
}

function useTextSelectionEffect(onSelectText, pos, end, transcriptID) {
    useEffect(() => {
        if ( pos && end ) {
            onSelectText(pos, end, transcriptID, 'Transcript');
        }
    }, [pos, end, transcriptID]);
}

function useSearchRedirectEffect(searchRedirect, transcriptID, search) {
    useEffect(() => {
        // search changed
        if ( search )
          searchRedirect(transcriptID, search);
    }, [search, transcriptID]);
}

export {
    useSelectSnippetEffect,
    useTextSelectionEffect,
    useSearchRedirectEffect
};
